export const PRODUCTOPTIONDETAIL_LOADING = "PRODUCTOPTIONDETAIL_LOADING";
export const PRODUCTOPTIONDETAIL_RESET = "PRODUCTOPTIONDETAIL_RESET";
export const GET_PRODUCTOPTIONDETAIL = "GET_PRODUCTOPTIONDETAIL";
export const GET_PRODUCTOPTIONDETAIL_SUCCESS = "GET_PRODUCTOPTIONDETAIL_SUCCESS";
export const GET_PRODUCTOPTIONDETAIL_FAIL = "GET_PRODUCTOPTIONDETAIL_FAIL";
export const DELETE_PRODUCTOPTIONDETAIL = "DELETE_PRODUCTOPTIONDETAIL"
export const DELETE_PRODUCTOPTIONDETAIL_SUCCESS = "DELETE_PRODUCTOPTIONDETAIL_SUCCESS"
export const DELETE_PRODUCTOPTIONDETAIL_FAIL = "DELETE_PRODUCTOPTIONDETAIL_FAIL"
export const UPDATE_PRODUCTOPTIONDETAIL = "UPDATE_PRODUCTOPTIONDETAIL"
export const UPDATE_PRODUCTOPTIONDETAIL_SUCCESS = "UPDATE_PRODUCTOPTIONDETAIL_SUCCESS"
export const UPDATE_PRODUCTOPTIONDETAIL_FAIL = "UPDATE_PRODUCTOPTIONDETAIL_FAIL"
export const ADD_NEW_PRODUCTOPTIONDETAIL = "ADD_NEW_PRODUCTOPTIONDETAIL"
export const ADD_PRODUCTOPTIONDETAIL_SUCCESS = "ADD_PRODUCTOPTIONDETAIL_SUCCESS"
export const ADD_PRODUCTOPTIONDETAIL_FAIL = "ADD_PRODUCTOPTIONDETAIL_FAIL"